const sentryConfig = {
  dsn: process.env.REACT_APP_SENTRY_DSN || ''
};

export { sentryConfig };
